import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { OverviewPage } from 'pages/settings/pages/billing/pages/overview/ui/overviewPage'

export const OverviewRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route path={'/'} element={<OverviewPage />} />
    </RoutesWithNotFound>
  )
})
